var $c302d0504fca332a$exports = {};
$c302d0504fca332a$exports = {
    "dropzoneLabel": `Ablegebereich`,
    "selectPlaceholder": `Element w\xe4hlen`,
    "tableResizer": `Gr\xf6\xdfenanpassung`
};


export {$c302d0504fca332a$exports as default};
//# sourceMappingURL=de-DE.module.js.map
